import { __require as b } from "./_baseIteratee.js";
import { __require as F } from "./isArrayLike.js";
import { __require as y } from "./keys.js";
var u, _;
function x() {
  if (_) return u;
  _ = 1;
  var s = b(), f = F(), q = y();
  function d(m) {
    return function(r, e, v) {
      var i = Object(r);
      if (!f(r)) {
        var n = s(e, 3);
        r = q(r), e = function(t) {
          return n(i[t], t, i);
        };
      }
      var a = m(r, e, v);
      return a > -1 ? i[n ? r[a] : a] : void 0;
    };
  }
  return u = d, u;
}
export {
  x as __require
};
